import dayjs from "dayjs";

export const verificarHoraDisponible = (hora, horasNoDispo) => {


    let horaReal = hora.hora + (hora.jornada === 'am' ? 0 : 12)
    let minutos = hora.minutos

    for (let i = 0; i < horasNoDispo.length; i++) {

        let cita = new dayjs(horasNoDispo[i].fechaCita)
        let horaCita = parseInt(cita.format('h'))
        let minutosCita = parseInt(cita.format('m'))
        let horaRealCita = cita.format('a') === 'am' ? horaCita : horaCita + 12
        if (horaReal === horaRealCita && minutos === minutosCita) {
            return true
        }
    }

    return false
}